import { render, staticRenderFns } from "./forgetModal.vue?vue&type=template&id=40fcb6cd"
import script from "./forgetModal.vue?vue&type=script&lang=js"
export * from "./forgetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports